import axiosInstance from "../interceptor/instance";

export const getAllFiles = async (params) => {
  const response = await axiosInstance.get(
    process.env.REACT_APP_BASE_URL_FILE,
    { params: params }
  );
  return response.data;
};
